import React from 'react';

// One page crashing while it renders must not blank the whole app. Shows a short message with a way back;
// a changed route resets it, so moving to another page works without a reload.
export default class ErrorBoundary extends React.Component {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error, info) {
    console.error('Page crashed:', error, info?.componentStack);
  }

  componentDidUpdate(prev) {
    if (this.state.failed && prev.resetKey !== this.props.resetKey) this.setState({ failed: false });
  }

  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <div role="alert" style={{ maxWidth: 480, margin: '15vh auto', padding: '0 20px', textAlign: 'center', fontFamily: 'inherit' }}>
        <h1 style={{ fontSize: 24, marginBottom: 8 }}>Something went wrong</h1>
        <p style={{ color: 'var(--t-muted)', marginBottom: 20 }}>This page hit a problem. Reloading usually fixes it.</p>
        <button type="button" onClick={() => window.location.reload()} style={{ height: 44, padding: '0 24px', borderRadius: 10, border: 'none', background: 'var(--t-btn)', color: '#fff', fontWeight: 600, cursor: 'pointer' }}>
          Reload the page
        </button>{' '}
        <a href="/" style={{ marginLeft: 12, color: 'var(--t-text)', fontWeight: 600 }}>Go to home</a>
      </div>
    );
  }
}
